import styled from "styled-components";

const DrillDownContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
export default DrillDownContainer;
